import { useForm, Controller } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import { useState } from "react";
import { Button, TextField, Card, CardContent, Typography, Box, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, CircularProgress, Alert } from "@mui/material";

import "./ConfigFormulario.css";

function SuccessScreen() {
    return (
        <Box className="container-sucess">
            <Card className="form-card">
                <CardContent>
                    <Typography variant="h4" textAlign="center" color="success.main">✅ Cadastro realizado com sucesso!</Typography>
                </CardContent>
            </Card>
        </Box>
    );
}

export default function ConfigFormulario() {
    const { register, handleSubmit, reset, control } = useForm();
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);
    const navigate = useNavigate();

    const sanitizeCPF = (cpf) => cpf.replace(/[^\d]/g, "");
    const sanitizePhone = (phone) => phone.replace(/[^\d]/g, "");
    const sanitizePlate = (plate) => plate.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

    const onSubmit = async (data) => {
        setLoading(true);
        setErrorMessage("");
        setIsSuccess(false);

        // Sanitiza os dados antes de enviar
        const payload = {
            ...data,
            cpf: sanitizeCPF(data.cpf),
            phone: sanitizePhone(data.phone),
            plate: sanitizePlate(data.plate)
        };

        try {

            try {
                const response = await fetch("https://api.deheus.yorbit.com.br/oapi/yOrForm", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                });

                if (response.status === 200) {
                    setIsSuccess(true);
                    reset();
                } else {
                    const result = await response.json();
                    window.alert(result.error || "Erro ao cadastrar");
                    setErrorMessage(result.error || "Erro ao cadastrar");
                }
            } catch (error) {
                window.alert("Erro ao conectar com o servidor, verifique sua conexão de internet.");
                setErrorMessage("Erro ao conectar com o servidor, verifique sua conexão de internet.");
            }
        } catch (error) {
            alert(error); // Exibe mensagens de erro amigáveis
        }

        setLoading(false);
    };

    if (isSuccess) {
        return <SuccessScreen />;
    }

    return (
        <Box className="container-form">
            <Card className="form-card">
                <CardContent>

                    <Typography variant="h6" className="title" ml={1}>
                        Bem Vindo a Portaria De Heus
                    </Typography>

                    {errorMessage && (
                        <Alert severity="error" sx={{ mt: 2 }}>{errorMessage}</Alert>
                    )}

                    <form onSubmit={handleSubmit(onSubmit)} className="form">
                        <Box mb={2} />

                        <FormControl component="fieldset" margin="dense" className="epi-group">
                            <Typography variant="h6" className="title" ml={1}>
                                Qual operação vai realizar?
                            </Typography>
                            <Controller
                                name="operation"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <RadioGroup row {...field}>
                                        <FormControlLabel value="carregamento" control={<Radio />} label="Carregamento" />
                                        <FormControlLabel value="descarregamento" control={<Radio />} label="Descarregamento" />
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>


                        <FormControl component="fieldset" margin="dense" className="epi-group">
                            <Typography variant="h6" className="title" ml={1}>
                                Qual unidade De Heus você se encontra?
                            </Typography>
                            <Controller
                                name="unit"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <RadioGroup row {...field}>
                                        <FormControlLabel value="b2782350-0655-11f0-b6fa-9f7aebdea2ec" control={<Radio />} label="Unidade 01 (Av. Brasil, 6624)" />
                                        <FormControlLabel value="813c4ab0-065e-11f0-a3b6-4dae11bd9299" control={<Radio />} label="Unidade 02 (Av. Brasil, 1590)" />
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>

                        <FormControl component="fieldset" margin="dense" className="epi-group">
                            <Typography variant="h6" className="title" ml={1}>
                                Vai carregar nas duas unidades?
                            </Typography>
                            <Controller
                                name="to_load"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <RadioGroup row {...field}>
                                        <FormControlLabel value="sim" control={<Radio />} label="Sim" />
                                        <FormControlLabel value="nao" control={<Radio />} label="Não" />
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>


                        <FormControl component="fieldset" margin="dense" className="epi-group">
                            <Typography variant="h6" className="title" ml={1}>
                                O caminhão já está carregado?
                            </Typography>
                            <Controller
                                name="loaded"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <RadioGroup row {...field}>
                                        <FormControlLabel value="sim" control={<Radio />} label="Sim" />
                                        <FormControlLabel value="nao" control={<Radio />} label="Não" />
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>


                        <TextField label="Nome Completo" {...register("name")} required fullWidth margin="dense" variant="outlined" />
                        <TextField label="CPF" {...register("cpf")} required fullWidth margin="dense" variant="outlined" inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }} />
                        <TextField label="Telefone" {...register("phone")} required fullWidth margin="dense" variant="outlined" inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }} />
                        <TextField label="Transportadora" {...register("carrier")} required fullWidth margin="dense" variant="outlined" />
                        <TextField label="Tipo Veículo: Ex. Truck. Bitruck. Carreta..." {...register("vehicle")} required fullWidth margin="dense" variant="outlined" />
                        <TextField label="Placa do Veiculo" {...register("plate")} required fullWidth margin="dense" variant="outlined" />
                        <TextField label="Numero da CG ou NOTA FISCAL" {...register("note_provider")} fullWidth margin="dense" variant="outlined" />

                        <FormControl component="fieldset" margin="dense" className="epi-group">
                            <Typography variant="h6" className="title" ml={1}>
                                Possui capacete de segurança?
                            </Typography>
                            <RadioGroup row {...register("epi_helmet")}>
                                <FormControlLabel value="sim" control={<Radio />} label="Sim" />
                                <FormControlLabel value="nao" control={<Radio />} label="Não" />
                            </RadioGroup>
                        </FormControl>

                        <FormControl component="fieldset" margin="dense" className="epi-group">
                            <Typography variant="h6" className="title" ml={1}>
                                Possui colete refletivo?
                            </Typography>
                            <RadioGroup row {...register("epi_vest")}>
                                <FormControlLabel value="sim" control={<Radio />} label="Sim" />
                                <FormControlLabel value="nao" control={<Radio />} label="Não" />
                            </RadioGroup>
                        </FormControl>
                        <FormControl component="fieldset" margin="dense" className="epi-group">
                            <Typography variant="h6" className="title" ml={1}>
                                Possui calçado fechado?
                            </Typography>
                            <RadioGroup row {...register("epi_boot")}>
                                <FormControlLabel value="sim" control={<Radio />} label="Sim" />
                                <FormControlLabel value="nao" control={<Radio />} label="Não" />
                            </RadioGroup>
                        </FormControl>
                        {/* <TextField label="Informações adicionais" {...register("others")} fullWidth margin="dense" variant="outlined" /> */}

                        <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading} sx={{ mt: 2 }}>
                            {loading ? <CircularProgress size={24} color="inherit" /> : "Cadastrar"}
                        </Button>
                    </form>
                </CardContent>
            </Card>
        </Box>
    );
}